import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-form-toggle',
    templateUrl: './form-toggle.component.html',
    styleUrl: './form-toggle.component.scss',
    host: {
        '[class.-open]': 'open()',
        '[class.grouped-form]': 'groupedLayout()',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FormToggleComponent {
    // #region inputs
    public multiplesAllowed = input<boolean>(true);
    public formGroup = input.required<FormGroup>();
    public objectIndex = input.required<number>();
    public objectsTotal = input.required<number>();
    public title = input<string>();
    public descriptionKey = input<string>();
    public allowRemovingSingleItem = input<boolean>(false);
    public forceGroupedLayout = input<boolean>(false);
    // #endregion

    // #region outputs
    public remove = output<number>();
    // #endregion

    protected open = signal<boolean>(true);

    // #region getters and computed signals
    protected groupedLayout = computed(
        () =>
            this.forceGroupedLayout() ||
            (this.multiplesAllowed() && this.objectsTotal() > 1) ||
            this.allowRemovingSingleItem(),
    );

    protected buttonTitle = computed(
        () =>
            `${this.multiplesAllowed() ? `${this.objectIndex() + 1}. ` : ''}${this.title()}${this.description ? `: ${this.description}` : ''}`,
    );

    protected showDeleteButton = computed(
        () => this.groupedLayout() && (this.allowRemovingSingleItem() || this.objectsTotal() > 1),
    );

    public get description(): string {
        return this.formGroup().get(this.descriptionKey())?.value;
    }

    public get valid(): boolean {
        return !!this.formGroup()?.valid;
    }
    // #endregion

    public constructor() {
        // collapse when valid and another item is added
        effect(() => {
            if (this.objectsTotal() !== this.objectIndex() + 1) {
                if (this.formGroup()?.valid) {
                    this.open.set(false);
                }
            } else {
                this.open.set(true);
            }
        });
    }

    public toggleClicked(): void {
        if (this.valid) {
            this.open.set(!this.open());
        }
    }
}
